export const api = {
  dashboard: '/user/dashboard',
}
